import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles/index";
import Divider from "@material-ui/core/Divider/index";
import ReactSelect from "../../UI/ReactSelectNotClear";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../../helpers/updateObject";

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#231B88",
  },
});

export default function Edit(props) {
  const token = useSelector((state) => state.auth.token);
  const { onHide, show } = props;
  const classes = useStyles();

  const [deviceUsersInfo, setDeviceUsersInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    deviceId: "",
  });

  const onDeviceUserInfo = () => {
    setIsLoading(true);
    const { deviceId } = filterInputs;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}device-user/user-info?${
          deviceId ? `&deviceId=${deviceId}` : ""
        }`,
        {
          headers: { Authorization: `bearer ${token}` },
        }
      )
      .then(({ data }) => {
        setIsLoading(false);
        setDeviceUsersInfo(data);
        setIsError(false);
      })
      .catch(() => {
        setIsLoading(false);
        setDeviceUsersInfo([]);
        setIsError(true);
      });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onDeviceUserInfo(filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [filterInputs]);

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
  };

  const [deviceId, setDeviceId] = useState();
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}device/select`)
      .then(({ data }) => {
        const deviceId = data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDeviceId(deviceId);
      });
  }, []);

  const [chooseDeviceOption, setChooseDeviceOption] = useState([]);

  function handleChangeDevice(value) {
    setChooseDeviceOption(value);
    filterInputsUpdate("deviceId", value.value);
  }

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="lg"
      aria-labelledby="edit"
      centered
      className="modal p-5"
    >
      <Modal.Header closeButton>
        <Modal.Title id="Edit">Əməkdaşlar</Modal.Title>
      </Modal.Header>
      <div className=" row mb-0 mt-5 mx-0 d-flex w-100 justify-content-end">
            <div className="col-lg-6 col-md-6 col-12">
              <ReactSelect
                suggestions={deviceId}
                handleChangeSingle={(value) => handleChangeDevice(value)}
                single={chooseDeviceOption}
                label="Qurğu seçin"
                placeholder="Qurğu seçin"
                inputId="deviceId"
              />
            </div>
          </div>

          <Divider className="w-100" />
      <Modal.Body className="log-body-modal">
        <div className=" bg-white rounded">
         

          <div>
            {isLoading ? (
              <div className={classes.progresRoot}>
                <CircularProgress className={classes.progress} />
              </div>
            ) : !isLoading && !isError ? (
              <div className="drawer-body">
                { deviceUsersInfo ? (
                  deviceUsersInfo.map((item, index) => {
                    return (
                      <div key={index} className="mt-5">
                        <p>Əməkdaşın adı: {item?.Name}</p>
                        <p>Əməkdaşın id'si: {item?.UserId}</p>
                        <Divider />
                      </div>
                    );
                  })
                ) : (
                    <div className="noInfo">
                    <img
                      src="/media/error/search.png"
                      className="info-img"
                      alt="information"
                    />
                    <h4>İnformasiya tapılmadı</h4>
                  </div>
                )}
              </div>
            ) : (
                <div className="noInfo">
                <img
                  src="/media/error/search.png"
                  className="info-img"
                  alt="information"
                />
                <h4>İnformasiya tapılmadı</h4>
              </div>
            )}





            
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
